import {Component, ViewChild} from '@angular/core';
import {Http} from '@angular/http';

import { DataTable } from './../../../services/DataTable';
import * as moment from 'moment';
import {LeadsService} from "../../../models/leads/leads.service";
import {LeadsModel} from "../../../models/leads/leads.model";
import {BadgesService} from "../../../models/badges/badges.service";
import {BadgesHelper} from "../../../services/BadgesHelper";
import { ToasterService} from 'angular2-toaster/angular2-toaster';
import { Router } from '@angular/router';
import {phoneFormatter} from "../../../helpers/phone-format";

@Component({
    selector: 'lead-schedule-list',
    templateUrl: 'lead-schedule-list.template.html',
    styleUrls: ['lead-schedule-list.component.css']
})
export class LeadScheduleListComponent {
    phoneFormatter = phoneFormatter;
    @ViewChild('leadCreateClient') public leadCreateClient;
    @ViewChild('leadCreateSchedule') public leadCreateSchedule;
    @ViewChild('leadEdit') public leadEdit;
    @ViewChild('scheduleCalendar') public scheduleCalendar;
    @ViewChild('snowNotes') public snowNotes;

    public todayTable: DataTable;
    public overdueTable: DataTable;

    public leadStatuses: Array<any>;

    protected Model: LeadsService;


    // ===========================================================
    // Init
    // ===========================================================

    constructor(
        private http: Http,
        public badgesService: BadgesService,
        public badgesHelper: BadgesHelper,
        public toasterService: ToasterService,
        private router: Router
    ) {

        var setQ = (() => {
            var a: any = document.createElement('a');
            a.href = this.router.url;
            var url: any = new URL(a.href);
            var q = url.searchParams.get('q');
            return (dataTable: any) => {
                if (q) dataTable.filter.q = q;
            };
        }) ();

        this.Model = new LeadsService(this.http);

        this.todayTable = new DataTable(this.Model, LeadScheduleListComponent.getTodayFields());
        setQ(this.todayTable);
        this.todayTable.fetch();

        this.overdueTable = new DataTable(this.Model, LeadScheduleListComponent.getOverdueFields());
        setQ(this.overdueTable);
        this.overdueTable.fetch();

        this.leadStatuses = LeadsService.getStatuses();

        this.badgesService.onChange.subscribe((badgesObject)=> {
            //badgesHelper.refreshEntity(badgesObject, this.dataTable);
            this.refreshTable();
        })
    }



    ngOnInit() {
        this.loadScheduleList();
    }


    // ===========================================================
    // Load Data
    // ===========================================================

    private loadScheduleList() {
        this.Model.getScheduleLIst()
            .map(r => r.json())
            .subscribe(
                (res) => {
                    let events = res.data.map(function(item){
                        item.start =  moment.utc(item.start).local().format('YYYY-MM-DD HH:mm:ss');
                        return item;
                    });
                    this.scheduleCalendar.updateEvents(events);
                },
                (error) => {
                    let errorData = JSON.parse(error._body);
                    console.log(errorData.message);
                });

    }

    public openNotesModal(entity: any) {
        entity.notes = entity.notes_list;
        this.snowNotes.show(entity);
        this.badgesService.removeChannel('leads/' + entity.id  + '/notes');
    }

    // ===========================================================
    // Actions
    // ===========================================================

    public showCreateClient(entity:LeadsModel) {
        this.leadCreateClient.show(entity);
    }

    public showEditLead(entity:LeadsModel) {
        this.leadEdit.show(entity);
    }

    public showCreateSchedule(entity:LeadsModel) {
        this.leadCreateSchedule.show(entity);
    }

    public  openFutureSchedule(leadId: number) {
        this.Model.getOne(leadId)
            .subscribe(
                (res) => {
                    this.leadCreateSchedule.show(res.data);
                },
                (error) => {
                    let errorData = JSON.parse(error._body);
                    console.log(errorData.message);
                });
    }

    undoCallback(entity: any) {
        this.Model.undoSchedule(entity.id)
            .subscribe(
                (res) => {
                    this.toasterService.pop('success', 'Success', 'Selected schedule canceled.');
                    this.refreshTable();
                },
                (error) => {
                    this.toasterService.pop('error', 'Error', 'Error. Try again.');
                });
    }


    // ===========================================================
    // Functions
    // ===========================================================

    public refreshTable() {
        this.todayTable.refresh();
        this.overdueTable.refresh();
        this.loadScheduleList();
    }

    private static getTodayFields(){
        return [{'visible':  LeadsService.LEAD_VISIBLE_SCHEDULE}, {'filter': LeadsService.LEAD_FILTER_TODAY}];
    }

    private static getOverdueFields(){
        return [{'visible':  LeadsService.LEAD_VISIBLE_SCHEDULE}, {'filter':  LeadsService.LEAD_FILTER_OVERDUE}];
    }
}


// WEBPACK FOOTER //
// ./src/app/views/leads/schedule-list/lead-schedule-list.component.ts